export default __webpack_public_path__ + "static/blob-01-065e9e4b9da1c36e04a5989ce8ca21bc.svg";